<template>
  <div>
    <div v-if="step == 0">
      <app-step0 @nextStep="nextStep" />
    </div>
    <div v-else-if="step == 1">
      <app-step1 :items="permissionReshte" @nextStep="nextStep" @prevStep="prevStep" />
    </div>

    <div v-else-if="step == 2">
      <app-step2 :reshte="selectedReshte" @nextStep="nextStep" @prevStep="prevStep" />
    </div>
  </div>
</template>

<script>
import Step0 from "./Step0";
import Step1 from "./Step1";
import Step2 from "./Step2";

import { saveRequest } from "@/api/tadris-permission";
import { toArabicCharacter } from "@/utils/constants";
export default {
  data() {
    return {
      step: 0,
      reshteFetched: false,
      schoolFetched: false,
      selectedReshte: null,
      selectedSchools: [],
    };
  },
  components: {
    appStep0: Step0,
    appStep1: Step1,

    appStep2: Step2,
  },
  created() {
    if (this.$route.query.step) {
      this.$router.replace({
        query: {}
      })
    }

  },
  methods: {
    nextStep(param) {
      switch (this.step) {
        case 0:
          if (!this.reshteFetched) {
            this.$store.dispatch("getPermissionReshte").then(() => {
              this.reshteFetched = true;
            });
          } else {
            if (this.permissionReshte.length == 0) {
              this.$store.commit(
                "SET_SNACKBAR_TEXT",
                "رشته ای برای تدریس وجود ندارد."
              );

              return;
            }
          }
          break;
        case 1:

          this.selectedReshte = param;

          break;
        case 2:
          var strSchools = [];
          for (var i = 0; i < this.selectedSchools.length; i++) {
            strSchools.push(this.selectedSchools[i].FSerial);
          }
          this.$store.commit("SET_API_RUNNING", true);
          saveRequest(
            param.image,
            this.selectedReshte.Value,
            param.ostan,
            param.comment
          )
            .then((response) => {
              const data = response.data;
              this.$store.commit("SET_SNACKBAR_TEXT", data.Message);
              this.$store.commit("SET_API_RUNNING", false);
              if (data.Success) {
                this.goToIndex();
              }
            })
            .catch((error) => {
              this.$store.commit(
                "SET_SNACKBAR_TEXT",
                "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
              );
            });
          break;
      }
      if (this.step < 2) {
        this.$router.push({
          query: {

            step: ++this.step
          }
        });
      }
    },
    prevStep() {
      this.$router.push({
        query: {

          step: --this.step
        }
      });
    },

    goToIndex() {
      this.$store.commit("SET_DIALOG_SHOW", false);
      this.$router.push({ path: "/index" });
    },
  },

  computed: {
    searchInput() {
      return this.$store.getters.searchInput;
    },
    permissionReshte() {
      var reshte = this.$store.getters.tadrisPermissionReshte;
      return reshte.filter((single) => {
        return (
          single.Value.toLowerCase().includes(this.searchInput.toLowerCase()) ||
          single.Text.toLowerCase().includes(
            toArabicCharacter(this.searchInput)
          )
        );
      });
    },

    isMobile() {
      return this.$store.getters.isMobile;
    },
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
  },
  watch: {

    '$route'(to, from) {
      this.step = this.$route.query.step ? Number(this.$route.query.step) : 0;
      window.scrollTo(0, 0)

    }
  },
};
</script>
